import React from "react";
import {
  Sbox,
  Scard,
  Scart,
  Scategory,
  SdownArrow,
  Sman,
  Sothers,
  Sreports,
  Sreturn,
  Ssale,
  Shome,
  Ssetting
} from "../../assets/icons/svgs";
import { Link, useLocation } from "react-router-dom";

const SidebarMenus = ({ collapsed, setCollapsed }) => {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <>
      {!collapsed && (
        <div className="sidebar-lg border-r-2">
          {!collapsed && (
            <div className="menu-scrollbar" data-scroll="1">
              <nav className="sidebar-navs">
                <ul className="sidebar-nav-items mb-16">
                  <li
                    className={
                      pathname === "/"
                        ? `sidebar-nav-item px-5 py-3 text-black bg-blue-100`
                        : `sidebar-nav-item px-5 py-3 text-gray-500`
                    }
                  >
                    <Link to="/">
                      <label
                        htmlFor="dashboard"
                        className=" flex  items-center"
                      >
                        <Shome />
                        <span
                          className={
                            pathname === "/"
                              ? "ml-4 font-semibold sidebar-menu-item"
                              : "ml-4 hover:text-black sidebar-menu-item"
                          }
                        >
                          Home
                        </span>
                      </label>
                    </Link>
                  </li>
                  <li
                    className={
                      pathname.includes("/products/")
                        ? `sidebar-nav-item px-5 py-3 text-black bg-blue-100`
                        : `sidebar-nav-item px-5 py-3 text-gray-500`
                    }
                  >
                    <input type="checkbox" id="products" className="checkbox" />
                    <label
                      htmlFor="products"
                      className="flex items-center justify-between hover:text-black sidebar-menu-item"
                    >
                      <div className="flex items-center">
                        <Scart />
                        <span
                          className={
                            pathname.includes("/products")
                              ? "ml-4 font-semibold"
                              : "ml-4"
                          }
                        >
                          Products
                        </span>
                      </div>
                      <SdownArrow />
                    </label>
                    <ul className="sidebar-nav-item-submenu collapse text-gray-500 text-left ">
                      <li
                        className={
                          pathname.includes("/products/all-products")
                            ? "px-3 py-3 text-black font-semibold"
                            : "px-3 py-3 hover:text-black"
                        }
                      >
                        <Link to="/products/all-products">
                          <i className="fa-solid fa-minus mr-3"></i>
                          <span>All Products</span>
                        </Link>
                      </li>
                      <li
                        className={
                          pathname.includes("/products/category-list")
                            ? "px-3 py-3 text-black font-semibold"
                            : "px-3 py-3 hover:text-black"
                        }
                      >
                        <Link to="/products/category-list">
                          <i className="fa-solid fa-minus mr-3"></i>
                          <span>Category List</span>
                        </Link>
                      </li>
                      <li
                        className={
                          pathname.includes("/products/add-new-product")
                            ? "px-3 py-3 text-black font-semibold"
                            : "px-3 py-3 hover:text-black"
                        }
                      >
                        <Link to="/products/add-new-product">
                          <i className="fa-solid fa-minus mr-3"></i>
                          <span>Add New Product</span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li
                    className={
                      pathname.includes("/sales/")
                        ? `sidebar-nav-item px-5 py-3 text-black bg-blue-100`
                        : `sidebar-nav-item px-5 py-3 text-gray-500`
                    }
                  >
                    <input type="checkbox" id="sales" className="checkbox" />
                    <label
                      htmlFor="sales"
                      className="flex items-center justify-between hover:text-black sidebar-menu-item"
                    >
                      <div className="flex items-center">
                        <Ssale />
                        <span
                          className={
                            pathname.includes("/sales/")
                              ? "ml-4 font-semibold"
                              : "ml-4"
                          }
                        >
                          Sales
                        </span>
                      </div>
                      <SdownArrow />
                    </label>
                    <ul className="sidebar-nav-item-submenu collapse text-gray-500 text-left">
                      <li
                        className={
                          pathname.includes("/sales/daily-sales")
                            ? "px-3 py-3 text-black font-semibold"
                            : "px-3 py-3 hover:text-black"
                        }
                      >
                        <Link to="/sales/daily-sales">
                          <i className="fa-solid fa-minus mr-3"></i>
                          <span>Daily Sales</span>
                        </Link>
                      </li>
                      <li
                        className={
                          pathname.includes("/sales/monthly-sales")
                            ? "px-3 py-3 text-black font-semibold"
                            : "px-3 py-3 hover:text-black"
                        }
                      >
                        <Link to="/sales/monthly-sales">
                          <i className="fa-solid fa-minus mr-3"></i>
                          <span>Monthly Sales</span>
                        </Link>
                      </li>
                      <li
                        className={
                          pathname.includes("/sales/total-sales")
                            ? "px-3 py-3 text-black font-semibold"
                            : "px-3 py-3 hover:text-black"
                        }
                      >
                        <Link to="/sales/total-sales">
                          <i className="fa-solid fa-minus mr-3"></i>
                          <span>Total Sales</span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li
                    className={
                      pathname.includes("/supplier/")
                        ? `sidebar-nav-item px-5 py-3 text-black bg-blue-100`
                        : `sidebar-nav-item px-5 py-3 text-gray-500`
                    }
                  >
                    <input
                      type="checkbox"
                      id="suppliers"
                      className="checkbox"
                    />
                    <label
                      htmlFor="suppliers"
                      className="flex items-center justify-between hover:text-black sidebar-menu-item"
                    >
                      <div className="flex items-center">
                        <Scategory />
                        <span
                          className={
                            pathname.includes("/supplier/")
                              ? "ml-4 font-semibold"
                              : "ml-4"
                          }
                        >
                          Supplier
                        </span>
                      </div>
                      <SdownArrow />
                    </label>
                    <ul className="sidebar-nav-item-submenu collapse text-gray-500 text-left">
                      <li
                        className={
                          pathname.includes("/supplier/supplier-list")
                            ? "px-3 py-3 text-black font-semibold"
                            : "px-3 py-3 hover:text-black"
                        }
                      >
                        <Link to="/supplier/supplier-list">
                          <i className="fa-solid fa-minus mr-3"></i>
                          <span>Supplier List</span>
                        </Link>
                      </li>
                      <li
                        className={
                          pathname.includes("/supplier/supplier-history")
                            ? "px-3 py-3 text-black font-semibold"
                            : "px-3 py-3 hover:text-black"
                        }
                      >
                        <Link to="/supplier/supplier-history">
                          <i className="fa-solid fa-minus mr-3"></i>
                          <span>Supplier History</span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li
                    className={
                      pathname.includes("/customer/")
                        ? `sidebar-nav-item px-5 py-3 text-black bg-blue-100`
                        : `sidebar-nav-item px-5 py-3 text-gray-500`
                    }
                  >
                    <input type="checkbox" id="customer" className="checkbox" />
                    <label
                      htmlFor="customer"
                      className="flex items-center justify-between hover:text-black sidebar-menu-item"
                    >
                      <div className="flex items-center">
                        <Sman />
                        <span
                          className={
                            pathname.includes("/customer/")
                              ? "ml-4 font-semibold"
                              : "ml-4"
                          }
                        >
                          Customer
                        </span>
                      </div>
                      <SdownArrow />
                    </label>
                    <ul className="sidebar-nav-item-submenu collapse text-gray-500 text-left">
                      <li
                        className={
                          pathname.includes("/customer/customer-history")
                            ? "px-3 py-3 text-black font-semibold"
                            : "px-3 py-3 hover:text-black"
                        }
                      >
                        <Link to="/customer/customer-history">
                          <i className="fa-solid fa-minus mr-3"></i>
                          <span>Customer History</span>
                        </Link>
                      </li>
                      <li
                        className={
                          pathname.includes("/customer/new-sales")
                            ? "px-3 py-3 text-black font-semibold"
                            : "px-3 py-3 hover:text-black"
                        }
                      >
                        <Link to="/customer/new-sales">
                          <i className="fa-solid fa-minus mr-3"></i>
                          <span>New Sales</span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li
                    className={
                      pathname === "/purchase"
                        ? `sidebar-nav-item px-5 py-3 text-black bg-blue-100`
                        : `sidebar-nav-item px-5 py-3 text-gray-500`
                    }
                  >
                    <Link to="/purchase">
                      <label
                        htmlFor="dashboard"
                        className=" flex  items-center"
                      >
                        <Scard />
                        <span
                          className={
                            pathname.includes("/purchase")
                              ? "ml-4 font-semibold sidebar-menu-item"
                              : "ml-4 hover:text-black sidebar-menu-item"
                          }
                        >
                          Purchasae
                        </span>
                      </label>
                    </Link>
                  </li>
                  <li
                    className={
                      pathname === "/sales-products"
                        ? `sidebar-nav-item px-5 py-3 text-black bg-blue-100`
                        : `sidebar-nav-item px-5 py-3 text-gray-500`
                    }
                  >
                    <Link to="/sales-products">
                      <label
                        htmlFor="dashboard"
                        className=" flex  items-center"
                      >
                        <Sreports />
                        <span
                          className={
                            pathname.includes("/sales-products")
                              ? "ml-4 font-semibold sidebar-menu-item"
                              : "ml-4 hover:text-black sidebar-menu-item"
                          }
                        >
                          Sales Products
                        </span>
                      </label>
                    </Link>
                  </li>
                  <li
                    className={
                      pathname === "/make-a-stuff"
                        ? `sidebar-nav-item px-5 py-3 text-black bg-blue-100`
                        : `sidebar-nav-item px-5 py-3 text-gray-500`
                    }
                  >
                    <Link to="/make-a-stuff">
                      <label className=" flex  items-center">
                        <Sreturn />
                        <span
                          className={
                            pathname.includes("/make-a-stuff")
                              ? "ml-4 font-semibold sidebar-menu-item"
                              : "ml-4 hover:text-black sidebar-menu-item"
                          }
                        >
                          Make a Stuff
                        </span>
                      </label>
                    </Link>
                  </li>
                  <li
                    className={
                      pathname === "/settings"
                        ? `sidebar-nav-item px-5 py-3 text-black bg-blue-100`
                        : `sidebar-nav-item px-5 py-3 text-gray-500`
                    }
                  >
                    <Link to="/settings">
                      <label
                        htmlFor="dashboard"
                        className=" flex  items-center"
                      >
                        <Ssetting />
                        <span
                          className={
                            pathname.includes("/settings")
                              ? "ml-4 font-semibold sidebar-menu-item"
                              : "ml-4 hover:text-black sidebar-menu-item"
                          }
                        >
                          Settings
                        </span>
                      </label>
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      )}

      {collapsed && (
        <div className="collapsed-sidebar border-r-2">
          <div className="collapsed-menu-scrollbar" data-scroll="1">
            <nav className="sidebar-navs">
              <ul className="sidebar-nav-items mb-16">
                <Link to="/">
                  <li
                    className={
                      pathname === "/"
                        ? ` flex w-full px-5 py-3 bg-blue-100 text-black`
                        : ` flex w-full px-5 py-3 text-gray-500`
                    }
                  >
                    <label
                      htmlFor="dashboard"
                      className="tooltip tooltip-right flex text-center  items-center"
                      data-tip="Home"
                    >
                      <Shome />
                    </label>
                  </li>
                </Link>
                <li
                  tabIndex={0}
                  className={
                    pathname.includes("/products/")
                      ? `cursor-pointer flex w-full dropdown dropdown-start px-5 py-3 text-black bg-blue-100`
                      : `cursor-pointer flex w-full dropdown dropdown-start px-5 py-3 text-gray-500 `
                  }
                >
                  <label
                    className="tooltip tooltip-right flex text-center  items-center"
                    data-tip="Products"
                  >
                    <Scart />
                  </label>
                  <div
                    tabIndex="0"
                    className="rounded-md mt-3 card card-compact dropdown-content w-52 bg-base-100 shadow"
                  >
                    <div className="card-body">
                      <ul className=" collapse text-gray-500 text-left">
                        <li className="pb-3">
                          <Link to="/products/all-products">
                            <i className="fa-solid fa-minus mr-3"></i>
                            <span
                              className={
                                pathname.includes("/products/all-products")
                                  ? "text-black font-semibold"
                                  : "hover:text-black"
                              }
                            >
                              All Products
                            </span>
                          </Link>
                        </li>
                        <li className="pb-3">
                          <Link to="/products/category-list">
                            <i className="fa-solid fa-minus mr-3"></i>
                            <span
                              className={
                                pathname.includes("/products/category-list")
                                  ? "text-black font-semibold"
                                  : "hover:text-black"
                              }
                            >
                              Category List
                            </span>
                          </Link>
                        </li>
                        <li className="">
                          <Link to="/products/add-new-product">
                            <i className="fa-solid fa-minus mr-3"></i>
                            <span
                              className={
                                pathname.includes("/products/add-new-product")
                                  ? "text-black font-semibold"
                                  : "hover:text-black"
                              }
                            >
                              Add New Product
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li
                  className={
                    pathname.includes("/sales/")
                      ? `cursor-pointer flex w-full dropdown dropdown-start px-5 py-3 text-black bg-blue-100`
                      : ` cursor-pointer flex w-full dropdown dropdown-start px-5 py-3 text-gray-500 `
                  }
                  tabIndex={0}
                >
                  <label
                    className="tooltip tooltip-right flex text-center  items-center"
                    data-tip="Sales"
                  >
                    <Ssale />
                  </label>
                  <div
                    tabIndex="0"
                    className="rounded-md mt-3 card card-compact dropdown-content w-52 bg-base-100 shadow"
                  >
                    <div className="card-body">
                      <ul className=" collapse text-gray-500 text-left">
                        <li className=" pb-3">
                          <Link to="/sales/daily-sales">
                            <i className="fa-solid fa-minus mr-3"></i>
                            <span
                              className={
                                pathname.includes("/sales/daily-sales")
                                  ? "text-black font-semibold"
                                  : "hover:text-black"
                              }
                            >
                              Daily Sales
                            </span>
                          </Link>
                        </li>
                        <li>
                          <Link to="/sales/monthly-sales">
                            <i className="fa-solid fa-minus mr-3"></i>
                            <span
                              className={
                                pathname.includes("/sales/monthly-sales")
                                  ? "text-black font-semibold"
                                  : "hover:text-black"
                              }
                            >
                              Monthly Sales
                            </span>
                          </Link>
                        </li>
                        <li className=" pt-3">
                          <Link to="/sales/total-sales">
                            <i className="fa-solid fa-minus mr-3"></i>
                            <span
                              className={
                                pathname.includes("/sales/total-sales")
                                  ? "text-black font-semibold"
                                  : "hover:text-black"
                              }
                            >
                              Total Sales
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li
                  className={
                    pathname.includes("/supplier/")
                      ? `cursor-pointer flex w-full dropdown dropdown-start px-5 py-3 text-black bg-blue-100`
                      : `cursor-pointer flex w-full dropdown dropdown-start px-5 py-3 text-gray-500 `
                  }
                  tabIndex={0}
                >
                  <label
                    className="tooltip tooltip-right flex text-center  items-center"
                    data-tip="Supplier"
                  >
                    <Scategory />
                  </label>
                  <div
                    tabIndex="0"
                    className="rounded-md mt-3 card card-compact dropdown-content w-52 bg-base-100 shadow"
                  >
                    <div className="card-body">
                      <ul className=" collapse text-gray-500 text-left">
                        <li className=" pb-3">
                          <Link to="/supplier/supplier-list">
                            <i className="fa-solid fa-minus mr-3"></i>
                            <span
                              className={
                                pathname.includes("/supplier/supplier-list")
                                  ? "text-black font-semibold"
                                  : "hover:text-black"
                              }
                            >
                              Supplier List
                            </span>
                          </Link>
                        </li>
                        <li>
                          <Link to="/supplier/supplier-history">
                            <i className="fa-solid fa-minus mr-3"></i>
                            <span
                              className={
                                pathname.includes("/supplier/supplier-history")
                                  ? "text-black font-semibold"
                                  : "hover:text-black"
                              }
                            >
                              Supplier History
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li
                  className={
                    pathname.includes("/customer/")
                      ? `cursor-pointer flex w-full dropdown dropdown-start px-5 py-3 text-black bg-blue-100`
                      : `cursor-pointer flex w-full dropdown dropdown-start px-5 py-3 text-gray-500 `
                  }
                  tabIndex={0}
                >
                  <label
                    className="tooltip tooltip-right flex text-center  items-center"
                    data-tip="Customer"
                  >
                    <Sman />
                  </label>
                  <div
                    tabIndex="0"
                    className="rounded-md mt-3 card card-compact dropdown-content w-52 bg-base-100 shadow"
                  >
                    <div className="card-body">
                      <ul className=" collapse text-gray-500 text-left">
                        <li className=" pb-3">
                          <Link to="/customer/customer-history">
                            <i className="fa-solid fa-minus mr-3"></i>
                            <span
                              className={
                                pathname.includes("/customer/customer-history")
                                  ? "text-black font-semibold"
                                  : "hover:text-black"
                              }
                            >
                              Customer History
                            </span>
                          </Link>
                        </li>
                        <li className="">
                          <Link to="/customer/new-sales">
                            <i className="fa-solid fa-minus mr-3"></i>
                            <span
                              className={
                                pathname.includes("/customer/new-sales")
                                  ? "text-black font-semibold"
                                  : "hover:text-black"
                              }
                            >
                              New Sales
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <Link to="/purchase">
                  <li
                    className={
                      pathname === "/purchase"
                        ? `cursor-pointer flex w-full px-5 py-3 text-black bg-blue-100`
                        : `cursor-pointer flex w-full px-5 py-3 text-gray-500`
                    }
                  >
                    <label
                      className="tooltip tooltip-right flex text-center  items-center"
                      data-tip="Purchase"
                    >
                      <Scard />
                    </label>
                  </li>
                </Link>
                <Link to="/sales-products">
                  <li
                    className={
                      pathname === "/sales-products"
                        ? `cursor-pointer flex w-full px-5 py-3 text-black bg-blue-100`
                        : `cursor-pointer flex w-full px-5 py-3 text-gray-500`
                    }
                  >
                    <label
                      className="tooltip tooltip-right flex text-center  items-center"
                      data-tip="Sales Products"
                    >
                      <Sreports />
                    </label>
                  </li>
                </Link>
                <Link to="/make-a-stuff">
                  <li
                    className={
                      pathname === "/make-a-stuff"
                        ? `flex w-full px-5 py-3 text-black bg-blue-100`
                        : `flex w-full px-5 py-3 text-gray-500`
                    }
                  >
                    <label
                      className="tooltip tooltip-right flex text-center  items-center"
                      data-tip="Make A Stuff"
                    >
                      <Sreturn />
                    </label>
                  </li>
                </Link>
                <Link to="/settings">
                  <li
                    className={
                      pathname === "/settings"
                        ? `flex w-full px-5 py-3 text-black bg-blue-100`
                        : `flex w-full px-5 py-3 text-gray-500`
                    }
                  >
                    <label
                      className="tooltip tooltip-right flex text-center  items-center"
                      data-tip="Settings"
                    >
                      <Ssetting />
                    </label>
                  </li>
                </Link>
              </ul>
            </nav>
          </div>
        </div>
      )}

      <div className="block md:hidden mobile-menu-wrapper absolute w-full h-full">
        <div
          className="overlay absolute w-full h-full top-0 left-0 z-20"
          onClick={() => {
            const mobileMenu = document.querySelector(".mobile-menu-wrapper");
            mobileMenu.classList.toggle("mobile-menu-wrapper-collapsed");
          }}
        ></div>
        <div className="sidebar absolute mobile-menu w-56 h-full top-0 left-0 bg-white z-20">
          <div className="menu-scrollbar" data-scroll="1">
            <nav className="sidebar-navs">
              <ul className="sidebar-nav-items mb-16">
                <li
                  className={
                    pathname === "/"
                      ? `sidebar-nav-item px-5 py-3 text-black bg-blue-100`
                      : `sidebar-nav-item px-5 py-3 text-gray-500`
                  }
                >
                  <Link to="/">
                    <label className=" flex  items-center">
                      <Shome />
                      <span
                        className={
                          pathname === "/"
                            ? "ml-4 font-semibold sidebar-menu-item"
                            : "ml-4 hover:text-black sidebar-menu-item"
                        }
                      >
                        Home
                      </span>
                    </label>
                  </Link>
                </li>
                <li
                  className={
                    pathname.includes("/products/")
                      ? `sidebar-nav-item px-5 py-3 text-black bg-blue-100`
                      : `sidebar-nav-item px-5 py-3 text-gray-500`
                  }
                >
                  <input
                    type="checkbox"
                    id="products-mb"
                    className="checkbox"
                  />
                  <label
                    htmlFor="products-mb"
                    className="flex items-center justify-between hover:text-black sidebar-menu-item"
                  >
                    <div className="flex items-center">
                      <Scart />
                      <span
                        className={
                          pathname.includes("/products")
                            ? "ml-4 font-semibold"
                            : "ml-4"
                        }
                      >
                        Products
                      </span>
                    </div>
                    <SdownArrow />
                  </label>
                  <ul className="sidebar-nav-item-submenu collapse text-gray-500 text-left ">
                    <li
                      className={
                        pathname.includes("/products/all-products")
                          ? "px-3 py-3 text-black font-semibold"
                          : "px-3 py-3 hover:text-black"
                      }
                    >
                      <Link to="/products/all-products">
                        <i className="fa-solid fa-minus mr-3"></i>
                        <span>All Products</span>
                      </Link>
                    </li>
                    <li
                      className={
                        pathname.includes("/products/category-list")
                          ? "px-3 py-3 text-black font-semibold"
                          : "px-3 py-3 hover:text-black"
                      }
                    >
                      <Link to="/products/category-list">
                        <i className="fa-solid fa-minus mr-3"></i>
                        <span>Category List</span>
                      </Link>
                    </li>
                    <li
                      className={
                        pathname.includes("/products/add-new-product")
                          ? "px-3 py-3 text-black font-semibold"
                          : "px-3 py-3 hover:text-black"
                      }
                    >
                      <Link to="/products/add-new-product">
                        <i className="fa-solid fa-minus mr-3"></i>
                        <span>Add New Product</span>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li
                  className={
                    pathname.includes("/sales/")
                      ? `sidebar-nav-item px-5 py-3 text-black bg-blue-100`
                      : `sidebar-nav-item px-5 py-3 text-gray-500`
                  }
                >
                  <input type="checkbox" id="sales-mb" className="checkbox" />
                  <label
                    htmlFor="sales-mb"
                    className="flex items-center justify-between hover:text-black sidebar-menu-item"
                  >
                    <div className="flex items-center">
                      <Ssale />
                      <span
                        className={
                          pathname.includes("/sales/")
                            ? "ml-4 font-semibold"
                            : "ml-4"
                        }
                      >
                        Sales
                      </span>
                    </div>
                    <SdownArrow />
                  </label>
                  <ul className="sidebar-nav-item-submenu collapse text-gray-500 text-left">
                    <li
                      className={
                        pathname.includes("/sales/daily-sales")
                          ? "px-3 py-3 text-black font-semibold"
                          : "px-3 py-3 hover:text-black"
                      }
                    >
                      <Link to="/sales/daily-sales">
                        <i className="fa-solid fa-minus mr-3"></i>
                        <span>Daily Sales</span>
                      </Link>
                    </li>
                    <li
                      className={
                        pathname.includes("/sales/monthly-sales")
                          ? "px-3 py-3 text-black font-semibold"
                          : "px-3 py-3 hover:text-black"
                      }
                    >
                      <Link to="/sales/monthly-sales">
                        <i className="fa-solid fa-minus mr-3"></i>
                        <span>Monthly Sales</span>
                      </Link>
                    </li>
                    <li
                      className={
                        pathname.includes("/sales/total-sales")
                          ? "px-3 py-3 text-black font-semibold"
                          : "px-3 py-3 hover:text-black"
                      }
                    >
                      <Link to="/sales/total-sales">
                        <i className="fa-solid fa-minus mr-3"></i>
                        <span>Total Sales</span>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li
                  className={
                    pathname.includes("/supplier/")
                      ? `sidebar-nav-item px-5 py-3 text-black bg-blue-100`
                      : `sidebar-nav-item px-5 py-3 text-gray-500`
                  }
                >
                  <input
                    type="checkbox"
                    id="suppliers-mb"
                    className="checkbox"
                  />
                  <label
                    htmlFor="suppliers-mb"
                    className="flex items-center justify-between hover:text-black sidebar-menu-item"
                  >
                    <div className="flex items-center">
                      <Scategory />
                      <span
                        className={
                          pathname.includes("/supplier/")
                            ? "ml-4 font-semibold"
                            : "ml-4"
                        }
                      >
                        Supplier
                      </span>
                    </div>
                    <SdownArrow />
                  </label>
                  <ul className="sidebar-nav-item-submenu collapse text-gray-500 text-left">
                    <li
                      className={
                        pathname.includes("/supplier/supplier-list")
                          ? "px-3 py-3 text-black font-semibold"
                          : "px-3 py-3 hover:text-black"
                      }
                    >
                      <Link to="/supplier/supplier-list">
                        <i className="fa-solid fa-minus mr-3"></i>
                        <span>Supplier List</span>
                      </Link>
                    </li>
                    <li
                      className={
                        pathname.includes("/supplier/supplier-history")
                          ? "px-3 py-3 text-black font-semibold"
                          : "px-3 py-3 hover:text-black"
                      }
                    >
                      <Link to="/supplier/supplier-history">
                        <i className="fa-solid fa-minus mr-3"></i>
                        <span>Supplier History</span>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li
                  className={
                    pathname.includes("/customer/")
                      ? `sidebar-nav-item px-5 py-3 text-black bg-blue-100`
                      : `sidebar-nav-item px-5 py-3 text-gray-500`
                  }
                >
                  <input
                    type="checkbox"
                    id="customer-mb"
                    className="checkbox"
                  />
                  <label
                    htmlFor="customer-mb"
                    className="flex items-center justify-between hover:text-black sidebar-menu-item"
                  >
                    <div className="flex items-center">
                      <Sman />
                      <span
                        className={
                          pathname.includes("/customer/")
                            ? "ml-4 font-semibold"
                            : "ml-4"
                        }
                      >
                        Customer
                      </span>
                    </div>
                    <SdownArrow />
                  </label>
                  <ul className="sidebar-nav-item-submenu collapse text-gray-500 text-left">
                    <li
                      className={
                        pathname.includes("/customer/customer-history")
                          ? "px-3 py-3 text-black font-semibold"
                          : "px-3 py-3 hover:text-black"
                      }
                    >
                      <Link to="/customer/customer-history">
                        <i className="fa-solid fa-minus mr-3"></i>
                        <span>Customer History</span>
                      </Link>
                    </li>
                    <li
                      className={
                        pathname.includes("/customer/new-sales")
                          ? "px-3 py-3 text-black font-semibold"
                          : "px-3 py-3 hover:text-black"
                      }
                    >
                      <Link to="/customer/new-sales">
                        <i className="fa-solid fa-minus mr-3"></i>
                        <span>New Sales</span>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li
                  className={
                    pathname === "/purchase"
                      ? `sidebar-nav-item px-5 py-3 text-black bg-blue-100`
                      : `sidebar-nav-item px-5 py-3 text-gray-500`
                  }
                >
                  <Link to="/purchase">
                    <label className=" flex  items-center">
                      <Scard />
                      <span
                        className={
                          pathname.includes("/purchase")
                            ? "ml-4 font-semibold sidebar-menu-item"
                            : "ml-4 hover:text-black sidebar-menu-item"
                        }
                      >
                        Purchase
                      </span>
                    </label>
                  </Link>
                </li>
                <li
                  className={
                    pathname === "/sales-products"
                      ? `sidebar-nav-item px-5 py-3 text-black bg-blue-100`
                      : `sidebar-nav-item px-5 py-3 text-gray-500`
                  }
                >
                  <Link to="/sales-products">
                    <label className=" flex  items-center">
                      <Sreports />
                      <span
                        className={
                          pathname.includes("/sales-products")
                            ? "ml-4 font-semibold sidebar-menu-item"
                            : "ml-4 hover:text-black sidebar-menu-item"
                        }
                      >
                        Sales Products
                      </span>
                    </label>
                  </Link>
                </li>
                <li
                  className={
                    pathname === "/make-a-stuff"
                      ? `sidebar-nav-item px-5 py-3 text-black bg-blue-100`
                      : `sidebar-nav-item px-5 py-3 text-gray-500`
                  }
                >
                  <Link to="/make-a-stuff">
                    <label className=" flex  items-center">
                      <Sreturn />
                      <span
                        className={
                          pathname.includes("/make-a-stuff")
                            ? "ml-4 font-semibold sidebar-menu-item"
                            : "ml-4 hover:text-black sidebar-menu-item"
                        }
                      >
                        Make a Stuff
                      </span>
                    </label>
                  </Link>
                </li>
                <li
                  className={
                    pathname === "/settings"
                      ? `sidebar-nav-item px-5 py-3 text-black bg-blue-100`
                      : `sidebar-nav-item px-5 py-3 text-gray-500`
                  }
                >
                  <Link to="/settings">
                    <label className=" flex  items-center">
                      <Ssetting />
                      <span
                        className={
                          pathname.includes("/settings")
                            ? "ml-4 font-semibold sidebar-menu-item"
                            : "ml-4 hover:text-black sidebar-menu-item"
                        }
                      >
                        Settings
                      </span>
                    </label>
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
};

export default SidebarMenus;
